import React, { useState } from "react"
import { Paper } from "@material-ui/core"
import Button from "@mui/material/Button"
import { HelveticaBold } from "common/typographies"
import i18n from "i18n"
import ModalTrademarks from "./ModalTrademarks"

const TrademarksSection = () => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Paper elevation={0} style={{ padding: "16px", height: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: 1 }}>
            <HelveticaBold
              style={{ fontSize: "18px", color: "#414141", marginBottom: 8 }}
            >
              {i18n.t("trademarkSettings.title")}
            </HelveticaBold>
            <div style={{ color: "#6d6d6d", fontSize: "14px", marginTop: 4 }}>
              {i18n.t("trademarkSettings.description")}
            </div>
          </div>
          <Button
            variant="contained"
            color="branded"
            style={{ marginLeft: 24, minWidth: 120 }}
            onClick={() => setOpen(true)}
          >
            {i18n.t("trademarkSettings.configure")}
          </Button>
        </div>
      </Paper>
      <ModalTrademarks open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default TrademarksSection
